<template>
  <div>
    <!-------------Start toast / snackbar --------------------------->
    <success-toast-component :SuccessToast="SuccessToast" @close="close" />
    <error-toast-component :ErrorToast="ErrorToast" @close="close" />
    <!-------------end toast / snackbar --------------------------->
    <!--------- heading ------------------->

    <v-row class="d-flex justify-space-between" flat>
      <v-col md="6" sm="6">
        <h1 class="heading-1">Polls and Surveys</h1>
      </v-col>
      <!--------------------------- add  --------------------------------------->
      <v-col md="6" sm="6">
        <v-card flat class="d-flex justify-end mt-2">
          <v-btn
            color="primary"
            dark
            class="text_style px-7"
            depressed
            to="/createpolls"
          >
            + Add New Poll
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
    <!--------- search , filter and buttons ------------------->
    <v-row class="mt-6">
      <v-col cols="12" md="4" sm="6">
        <v-card flat>
          <v-text-field
            dense
            outlined
            prepend-inner-icon="mdi-magnify"
            label="Search"
            single-line
            v-model="search"
          >
          </v-text-field>
        </v-card>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <!-- <v-card
          height="45"
          outlined
          class="px-2 mt-n1 d-flex justify-start align-center"
          style="cursor: pointer"
        >
          <div
            class="d-flex justify-space-between align-center"
            style="width: 100%"
          >
            <div>
              <v-icon>mdi-tune</v-icon>
              <span class="text_style mx-1" style="letter-spacing: 1px"
                >Filters</span
              >
            </div>

            <div>
              <v-icon>mdi-menu-down</v-icon>
            </div>
          </div>
        </v-card> -->
      </v-col>
    </v-row>
    <!--------- data table ------------------->
    <v-card class="mt-6" outlined>
      <v-data-table
        :search="search"
        :headers="headers"
        :loading="tableLoader"
        loading-text="Loading... Please wait"
        :items="downloadDataTableOne"
        :page.sync="page"
        :items-per-page="displayedItemsPerPage"
        @page-count="pageCount = $event"
        hide-default-footer
      >
        <template v-slot:[`item.index`]="{ index }">
          <b> {{ index + displayedItemsPerPage * (page - 1) + 1 }} </b>
        </template>
        <template v-slot:[`item.location`]="{ item }">
          <span class="table_style_two"> {{ item.location }} </span>
        </template>
        <template v-slot:[`item.date`]="{ item }">
          <span class="table_style_two"> {{ item.date }} </span>
        </template>
        <template v-slot:[`item.modality`]="{ item }">
          <span class="table_style_two"> {{ item.modality }} </span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon @click="toggleIsPlaying(item.index)" class="mx-5">
            <v-icon v-if="item.isPlaying" color="primary">mdi-eye</v-icon>
            <v-icon v-else>mdi-eye-off</v-icon>
          </v-btn>
          <!-- <router-link to="/previewpolls">
            <v-icon color="primary" class="mr-2">mdi-arrow-right-thin</v-icon>
          </router-link> -->
          <v-menu transition="scroll-y-transition" offset-y color="transparent">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="A1A1A6" v-bind="attrs" v-on="on">
                mdi-dots-horizontal
              </v-icon>
            </template>
            <v-card flat>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="sendsurveydialog = true"
                >
                  <v-icon color="#646464">mdi-share-variant</v-icon>
                  <span class="ml-4 text_style">Share</span>
                </v-btn>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent">
                <router-link to="/report">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                  >
                    <v-icon color="#646464">mdi-poll</v-icon>
                    <span class="ml-4 text_style">Report</span>
                  </v-btn>
                </router-link>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  to="/preview"
                >
                  <v-icon color="#646464">mdi-file-search</v-icon>
                  <span class="ml-4 text_style">Preview</span>
                </v-btn>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  to="/editpoll"
                >
                  <v-icon color="#646464">mdi-pencil</v-icon>
                  <span class="ml-4 text_style">Edit</span>
                </v-btn>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="dialog = true"
                >
                  <v-icon color="#646464">mdi-delete</v-icon>
                  <span class="ml-4 text_style">Delete</span>
                </v-btn>
              </v-list>
            </v-card>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <v-card flat class="my-9 d-flex justify-end align-center">
      <span class="text_transform pa-0 ma-0">Per page : </span>
      <v-card flat width="100" class="mx-5">
        <v-select
          :items="ItemsPerPageItems"
          label="Items per page"
          v-model="itemsPerPage"
        ></v-select>
      </v-card>
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="5"
      ></v-pagination
    ></v-card>

    <!-------------------History dialog-------------------------->
    <v-dialog v-model="historydialog" persistent max-width="530">
      <v-card>
        <div class="mx-9 py-5 d-flex justify-space-between">
          <div class="dialogHeading">History</div>
          <v-icon @click="historydialog = false">mdi-close</v-icon>
        </div>
        <HistoryComponent></HistoryComponent>
      </v-card>
    </v-dialog>
    <!-------------------Send Survey---------------------------------->
    <v-dialog v-model="sendsurveydialog" persistent max-width="530">
      <v-card>
        <div class="mx-9 py-5 d-flex justify-space-between">
          <div class="dialogHeading">Share [name_survey]</div>
          <v-icon @click="sendsurveydialog = false">mdi-close</v-icon>
        </div>
        <SendSurveyComponent
          :sendsurvey="sendsurveydialog"
          @close="close"
        ></SendSurveyComponent>
      </v-card>
    </v-dialog>
    <!----------Edit dialog------------------>
    <v-dialog v-model="editdialog" persistent max-width="700">
      <v-card>
        <div class="mx-5 py-5 d-flex justify-space-between">
          <h5>Edit desgin are not avaiable</h5>
          <v-icon @click="editdialog = false">mdi-close</v-icon>
        </div>
        <div>
          <!-- <edit-vedio-component /> -->
        </div>
        <div class="d-flex justify-end mx-5 py-5">
          <v-btn
            class="px-14 py-6 text_style"
            color="#A1A3A8"
            text
            @click="editdialog = false"
          >
            Cancel
          </v-btn>
          <v-btn color="primary" class="px-14 py-6 text_style" @click="send()">
            <span class="text_style" v-if="btnloader != true">Save</span>
            <v-progress-circular
              v-else
              indeterminate
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!----------Delete dialog------------------>
    <v-dialog v-model="dialog" persistent max-width="390">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="red darken-1" text @click="DdialogClose()">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
import SuccessToastComponent from "../../components/Toast/SuccessToast.component.vue";
import HistoryComponent from "../../components/Polls/history.component.vue";
import SendSurveyComponent from "../../components/Polls/sendsurvey.component.vue";

export default {
  components: {
    SuccessToastComponent,
    ErrorToastComponent,
    HistoryComponent,
    SendSurveyComponent,
  },
  data() {
    return {
      search: "",
      sendsurveydialog: false,
      historydialog: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      SuccessToast: false,
      ErrorToast: false,
      uploadfiledialog: false,
      createnewgroupdialog: false,
      editdialog: false,
      btnloader: false,
      tableLoader: false, // data-table true or false
      dialog: false,
      headers: [
        { text: "#", value: "index" },
        { text: "Title", value: "name" },
        { text: "Completed", value: "completed" },
        { text: "Start Date", value: "lastUpdate" },
        { text: "", value: "actions", sortable: false },
      ],
      downloadDataTableOne: [],
    };
  },

  mounted() {
    this.tableLoader = true;
    setTimeout(() => {
      (this.downloadDataTableOne = [
        {
          index: 1,
          name: "[Name_or_title_survey]",
          completed: "53",
          lastUpdate: "12/1/2022",
          isPlaying: true,
        },
        {
          index: 2,
          name: "[Name_or_title_survey]",
          completed: "53",
          lastUpdate: "12/1/2022",
          isPlaying: true,
        },
        {
          index: 3,
          name: "[Name_or_title_survey]",
          completed: "53",
          lastUpdate: "12/1/2022",
          isPlaying: false,
        },
        {
          index: 4,
          name: "[Name_or_title_survey]",
          completed: "53",
          lastUpdate: "12/1/2022",
          isPlaying: false,
        },
        {
          index: 5,
          name: "[Name_or_title_survey]",
          completed: "53",
          lastUpdate: "12/1/2022",
          isPlaying: true,
        },
      ]),
        (this.tableLoader = false);
    }, 1500);
  },
  computed: {
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.downloadDataTableOne.length
        : this.itemsPerPage;
    },
  },
  methods: {
    DdialogClose() {
      this.dialog = false;
      this.ErrorToast = true;
      setTimeout(() => {
        this.ErrorToast = false;
      }, 1500);
    },
    goBack() {
      this.isHidden = false;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.editdialog = false;
        this.btnloader = false;
        this.uploadfiledialog = false;
        this.createnewgroupdialog = false;
        this.SuccessToast = true;
      }, 2000);
      setTimeout(() => {
        this.SuccessToast = false;
      }, 3000);
    },
    close() {
      this.SuccessToast = false;
      this.ErrorToast = false;
      this.sendsurveydialog = false;
    },
  },
};
</script>

<style scoped>
.dialogHeading {
  font-family: "Merriweather";
  font-size: 24px;
  font-weight: 400;
}
h1 {
  font-family: "Noto Serif";
  font-size: 40px;
  font-weight: 700;
  line-height: 54px;
  color: rgba(34, 34, 34, 1);
}
.gray {
  color: #646464;
}
.previewHeading {
  font-family: "DM Sans";
  font-size: 24px;
  font-weight: 700;
}
@media screen and (max-width: 430px) {
  .mobile_size_h1 {
    font-size: 6vw;
  }
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
</style>
